import { styled } from '@clickcease/cc-client-components-lib'

export const PieWrapperStyled = styled('section', {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  width: '40%',
})

export const PieTotalStyled = styled('section', {
  position: 'absolute',
  display: 'block',
  bottom: '0%',
  left: '0',
  width: '100%',
  textAlign: 'center',

  span: {
    fontSize: '$lg',
    fontWeight: '$sb',
  },
})
